export default __webpack_public_path__ + "static/media/abstracto3768.fb50ae2d.jpg";